<template>
  <figure :class="$options.name">
    <span :class="$options.name + '__wrap'">
      <img :src="src" :alt="alt" />
    </span>
    <figcaption :class="$options.name + '__caption'" v-if="caption">
      <p>{{ captionStripped(caption) }}</p>
    </figcaption>
  </figure>
</template>
<script>
export default {
  name: "Img",
  methods: {
    captionStripped(caption) {
      let logic = new RegExp("#([^\\s]*)", "g");
      return caption.replace(logic, "");
    },
  },
  props: {
    alt: { default: "Img alt text" },
    caption: { default: null },
    src: { default: "" },
  },
};
</script>
<style lang="scss">
.Img {
  &__wrap {
    display: block;
    text-align: center;
  }
  &__caption {
    border-top: rem(1) solid var(--base-ghost);
    padding: rem(8) rem(16);
    text-align: center;
  }
}
</style>
